import { render, staticRenderFns } from "./AddTransactionComponent.vue?vue&type=template&id=47822b8c&"
import script from "./AddTransactionComponent.vue?vue&type=script&lang=js&"
export * from "./AddTransactionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports